import { createSlice } from "@reduxjs/toolkit";
import { assign } from "lodash";
const PortfolioCreationInitialState = {
    compositionRules: {},
    information: {
        currency: "",
        isAnalyticalPortfolio: true,
        name: "",
        portfolioStartDate: new Date()
    },
    selectedTab: 0,
    step: 1
};
const slice = createSlice({
    initialState: PortfolioCreationInitialState,
    name: "portfolioCreationReducers",
    reducers: {
        changePortfolioCreationStep: (state, action) => {
            if (action.payload) {
                state.step = action.payload;
            }
        },
        resetPortfolioCreation: (state) => {
            assign(state, PortfolioCreationInitialState);
        },
        setCompositionRules: (state, action) => {
            state.compositionRules = action.payload;
        },
        setPortfolioGeneralInformation: (state, action) => {
            if (action.payload) {
                assign(state.information, action.payload);
            }
        },
        setSelectedTabUid: (state, action) => {
            state.selectedTab = action.payload;
            state.fundBased = action.payload === 1;
        }
    }
});
export const portfolioCreationReducers = slice.reducer;
export const { changePortfolioCreationStep, setCompositionRules, setPortfolioGeneralInformation, resetPortfolioCreation, setSelectedTabUid } = slice.actions;
